import React, { useState } from 'react';
import { XIcon, ServerIcon, DatabaseIcon, BookOpenIcon } from 'lucide-react';
import { CustomApiForm } from './CustomApiForm';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConnect: (data: any) => void;
}
const INTEGRATION_TYPES = [{
  id: 'crm',
  name: 'CRM System',
  icon: DatabaseIcon,
  description: 'Connect to your CRM system to sync customer data',
  color: 'text-purple-400',
  bgColor: 'bg-purple-400/10'
}, {
  id: 'wiki',
  name: 'Knowledge Base',
  icon: BookOpenIcon,
  description: 'Import documentation from your knowledge base',
  color: 'text-green-400',
  bgColor: 'bg-green-400/10'
}, {
  id: 'custom',
  name: 'Custom API',
  icon: ServerIcon,
  description: 'Connect to any REST API endpoint',
  color: 'text-blue-400',
  bgColor: 'bg-blue-400/10'
}];
export const ConnectApiModal = ({
  isOpen,
  onClose,
  onConnect
}: Props) => {
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleConnect = async (data: any) => {
    setIsSubmitting(true);
    try {
      await onConnect({
        type: selectedType,
        ...data
      });
      onClose();
    } catch (error) {
      console.error('Failed to connect:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-657">
      <div className="bg-surface-light border border-surface-border rounded-none w-full max-w-2xl" data-id="element-658">
        <div className="px-6 py-4 border-b border-surface-border flex items-center justify-between" data-id="element-659">
          <h2 className="text-lg font-medium text-white font-mono" data-id="element-660">
            Connect New API
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-300 transition-colors" data-id="element-661">
            <XIcon size={20} data-id="element-662" />
          </button>
        </div>
        <div className="p-6" data-id="element-663">
          {!selectedType ? <div className="space-y-6" data-id="element-664">
              <p className="text-sm text-gray-400" data-id="element-665">
                Choose the type of API you want to connect to your knowledge
                space.
              </p>
              <div className="grid gap-4" data-id="element-666">
                {INTEGRATION_TYPES.map(type => <button key={type.id} onClick={() => setSelectedType(type.id)} className="flex items-start gap-4 p-4 bg-surface border border-surface-border rounded-none hover:bg-surface-mid transition-colors text-left" data-id="element-667">
                    <div className={`p-2 rounded-none ${type.bgColor} ${type.color}`} data-id="element-668">
                      <type.icon size={20} data-id="element-669" />
                    </div>
                    <div data-id="element-670">
                      <h3 className="text-sm font-medium text-white font-mono mb-1" data-id="element-671">
                        {type.name}
                      </h3>
                      <p className="text-sm text-gray-400" data-id="element-672">
                        {type.description}
                      </p>
                    </div>
                  </button>)}
              </div>
            </div> : <CustomApiForm type={selectedType} onBack={() => setSelectedType(null)} onSubmit={handleConnect} isSubmitting={isSubmitting} data-id="element-673" />}
        </div>
      </div>
    </div>;
};